import { createBrowserHistory } from 'history';

const history = process.env.NODE_ENV === 'development' ?
  createBrowserHistory() :
  createBrowserHistory();

export default history;